export const GET_AUDIT =
  'src/modules/audit/GET_AUDIT';
export const SAVE_AUDIT =
  'src/modules/audit/SAVE_AUDIT';
export const SET_AUDIT =
  'src/modules/audit/SET_AUDIT';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/audit/CANCEL_ALL_API_REQUESTS';
